import { request } from '@/utils/request'
export default {
    systemList: (params, loading) => {
        return request('/api/web/intelligent/list', params, loading)
    },
    systemDetail: (params, loading) => {
        return request('/api/web/intelligent/detail', params, loading)
    },
}


// WEBPACK FOOTER //
// ./src/api/smartSystem.js